const config = {
    apiKey: "AIzaSyCyYkeppqgrrlbEkni3UjPHsyrTThiqjzE",
    authDomain: "tarantula-7aeb6.firebaseapp.com",
    databaseURL: "https://tarantula-7aeb6.firebaseio.com",
    projectId: "tarantula-7aeb6",
    storageBucket: "tarantula-7aeb6.appspot.com",
    messagingSenderId: "255535431817"
  };

  export default config


// WEBPACK FOOTER //
// ./src/FBconfig.js